
import React, { useState } from "react";
import { View, ScrollView, SafeAreaView, StyleSheet, Picker, Text, TouchableOpacity, Image } from "react-native";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { i18n } from './../../../assets/lang/i18next';
const useStyles = makeStyles(() => ({
    textField: {
        width: "100%",
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        paddingBottom: 0,
        marginTop: 0,
        fontWeight: 500,
        fontSize: 13,
        direction: "rtl",
        "& .MuiFormLabel-root": {
            color: "black",
            textAlign: 'right',
            fontFamily: 'IranSans',
            fontSize: 13, direction: 'rtl', width: '100%',
        },
        "& .MuiInputLabel-asterisk": {
            color: '#d12023',
            fontWeight: 900,
        },
        "& .MuiInputBase-input": {
            color: '#333', textAlign: 'center'
        },
        '& label.Mui-focused': {
            color: '#333',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'yellow',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'white',
            },
            '&:hover fieldset': {
                borderColor: 'blue',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#333',
            },
        },

    },
    labelRoot: {
        right: 20,
    },
    shrink: {
        transformOrigin: "top right",
    },
    input: {
        color: "black", fontFamily: 'IranSans',
        fontSize: 13,

    },
    btn_calculate: {
        color: '#333',
        backgroundColor: 'gray',
        fontFamily: 'IranSans',
        fontSize: 13, fontWeight: 900,
    }
}));



const EvapratorByCalculate = props => {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const [selectmobared, setSelectmobared] = useState("R22");
    const [selectvahedzarfoyat, setSelectvahedzarfiyat] = useState(1);
    const [txtzarfiyatevaprator, setTxtzarfiyatevaprator] = useState("");
    const [txtte, setTxtTe] = useState("");
    const [txtdeltat, setTxtdeltat] = useState("");
    const [selectfaselefin, setSelectfaselefin] = useState(0);
    const [Sselectghotrefan, setSelectghotrefan] = useState(0);
    let fc = 0, qn = 0, zarfiyatevapconvert = 0;

    function FUNCMOHASEBEH() {
        switch (parseFloat(txtdeltat)) {
            case 5:
                fc = (0.7109825 + (0.02437231 * (txtte)) + (0.001258625 * (Math.pow(txtte, 2))) + (0.00003948019 * (Math.pow(txtte, 3))) + (0.0000006536131 * (Math.pow(txtte, 4))) + (0.000000004307692 * (Math.pow(txtte, 5))));
                break;
            case 6:
                fc = (0.8709434 + (0.03498631 * (txtte)) + (0.002442587 * (Math.pow(txtte, 2)) + (0.00009775781 * (Math.pow(txtte, 3))) + (0.000001914033 * (Math.pow(txtte, 4))) + (0.00000001421538 * (Math.pow(txtte, 5)))));
                break;
            case 7:
                fc = (1.050832 + (0.03611483 * (txtte)) + (0.00191451 * (Math.pow(txtte, 2))) + (0.0000595303 * (Math.pow(txtte, 3))) + (0.0000009655012 * (Math.pow(txtte, 4))) + (0.00000000625641 * (Math.pow(txtte, 5))));
                break;
            case 8:
                fc = (1.245332 + (0.0481014 * (txtte)) + (0.003071678 * (Math.pow(txtte, 2))) + (0.0001145338 * (Math.pow(txtte, 3))) + (0.00000213986 * (Math.pow(txtte, 4))) + (0.00000001538462 * (Math.pow(txtte, 5))));
                break;
            case 9:
                fc = (1.245332 + (0.0481014 * (txtte)) + (0.003071678 * (Math.pow(txtte, 2))) + (0.0001145338 * (Math.pow(txtte, 3))) + (0.00000213986 * (Math.pow(txtte, 4))) + (0.00000001538462 * (Math.pow(txtte, 5))));
                break;
            case 10:
                fc = (1.604168 + (0.06317434 * txtte) + (0.00436317 * (Math.pow(txtte, 2))) + (0.0001764953 * (Math.pow(txtte, 3))) + (0.00000357296 * (Math.pow(txtte, 4))) + (0.00000002758974 * (Math.pow(txtte, 5))));
                break;
        }
        qn = parseFloat(txtzarfiyatevaprator * selectvahedzarfoyat) / (fc);
        switch (selectmobared) {
            case "R22":
                qn = qn;
                break;
            case "R134":
                qn = parseFloat(qn) * parseFloat(0.97);
                break;
            case "R404a/R507a":
                qn = parseFloat(qn) * parseFloat(1.05);
                break;
        }
       props.navigation.navigate('EvapratorResult', { WHICH: 1, QN: qn, FIN: selectfaselefin, FAN: Sselectghotrefan ,MOBARED:selectmobared});



    }
    return (
        <ScrollView>
            <SafeAreaView style={styles.container}>
                <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between', width: '90%' }}>

                    <TouchableOpacity style={{ marginTop: 15,flex:1,flexDirection:'row' }} onPress={()=>props.navigation.navigate('CompEvaprator')}>
                        <Image resizeMode="contain" source={require('../../../assets/icons/comparisonicon.png')} style={{ width: 35, height: 35 }} />
                        <Text style={{fontSize:12,marginTop:7,fontFamily:'IranSans',color:'blue'}}>{t('ComparisonEvaprator')}</Text>
                    </TouchableOpacity>
                    <Text style={{ fontFamily: 'IranSans', fontWeight: 900, fontSize: 14, marginTop: 15, marginBottom: 10 }}>{t('Evaporatorselectionbasedoncalculation')}</Text>

                </View>
                <View style={styles.form}>
                    <Text style={styles.titleform}>{t('selectyourrefrigerant')}</Text>

                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectmobared(itemValue);
                        }}
                    >
                        <Picker.Item label="R22" value="R22" />
                        <Picker.Item label="R134" value="R134" />
                        <Picker.Item label="R404/R507a" value="R404/R507a" />

                    </Picker>
                    <TextField
                        label={t('EvaporatorCapacity')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('EvaporatorCapacity')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => setTxtzarfiyatevaprator(e.target.value)}
                        value={txtzarfiyatevaprator}
                        onWheel={(e) => e.target.blur()}
                    />
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectvahedzarfiyat(itemValue);
                        }}
                    >
                        <Picker.Item label={t('EvaporatorCapacitybasedonKW')} value="1" />
                        <Picker.Item label={t('basedonKCalhr')} value="859.845228" />
                        <Picker.Item label={t('Btuhr')} value="3412.116334" />
                        <Picker.Item label={t('TonTR')} value="0.284345" />
                    </Picker>
                    <TextField
                        label={t('Evaporatingtemperature')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('evaporation')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => {
                            setTxtTe(e.target.value)
                        }}
                        value={txtte}
                        onWheel={(e) => e.target.blur()}
                    />

                    <TextField
                        label={t('DeltaTc')}
                        onFocus={(e) => e.target.select()}
                        variant="filled"
                        placeholder={t('Acceptablevalues5678910')}
                        className={classes.textField}
                        required
                        type="number"
                        InputProps={{
                            className: classes.input
                        }}
                        InputLabelProps={{
                            classes: { root: classes.labelRoot, shrink: classes.shrink }
                        }}
                        margin="normal"
                        onChange={(e) => {
                            setTxtdeltat(e.target.value)
                        }}
                        value={txtdeltat}
                        onWheel={(e) => e.target.blur()}
                    />

                    <Text style={styles.titleform}>{t('Finspace')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectfaselefin(itemValue);
                        }}
                    >
                        <Picker.Item label={t('Aseries-finspacing4.5mm')} value="0" />
                        <Picker.Item label={t('Eseries-finspacing6.5mm')} value="1" />
                        <Picker.Item label={t('Fseries-finspacing9mm')} value="2" />
                        <Picker.Item label={t('Tseries-finspacing12mm')} value="3" />

                    </Picker>

                    <Text style={styles.titleform}>{t('FanDiameter(cm)')}</Text>
                    <Picker
                        mode="dropdown"
                        style={styles.dropdown}
                        onValueChange={(itemValue, itemIndex) => {
                            setSelectghotrefan(itemValue);
                        }}
                    >
                        <Picker.Item label={t('all')} value="0" />
                        <Picker.Item label="35" value="35" />
                        <Picker.Item label="42" value="42" />
                        <Picker.Item label="50" value="50" />
                        <Picker.Item label="63" value="63" />
                    </Picker>

                    <TouchableOpacity onPress={() => {
                        FUNCMOHASEBEH();

                    }} style={{ backgroundColor: '#022a4c', color: 'white', padding: 15, margin: 15, borderRadius: 4 }}>
                        <Text style={styles.titlebutton}>
                            {t('Computing')}
                        </Text>
                    </TouchableOpacity>

                </View>
            </SafeAreaView>
        </ScrollView>
    )
}

export default EvapratorByCalculate;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        backgroundColor: '#ebecec',

    }
    ,
    titleform: {
        marginBottom: 10,
        marginTop: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
    }
    ,
    inputtext: {
        backgroundColor: '#fff',
        textAlign: 'center',
        borderColor: "gray",
        width: "100%",
        borderWidth: 1,
        borderRadius: 10,
        padding: 10, width: '100%', height: 30
    }
    ,
    dropdown: {
        height: 50,
        width: '100%',
        marginBottom: 10,
        fontFamily: 'IranSans',
        fontSize: 13,
        borderWidth: 0,
        textAlign: 'center',
        backgroundColor: '#c9c9c9',
        direction: 'rtl',



    },
    form: {
        width: '90%',
        backgroundColor: '#ddd',
        margin: 10,
        padding: 10,
        justifyContent: 'center',
        alignItems: 'stretch',
        shadowColor: '#000',
        shadowOffset: { width: 1, height: 0.5 },
        shadowOpacity: 0.7,
        shadowRadius: 3,
    }
    ,
    touchable: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 12,
        paddingHorizontal: 32,
        borderRadius: 4,
        elevation: 3,
        backgroundColor: 'blue',
        marginBottom: 15,
        margin: 15,
    },
    titlebutton: {

        fontSize: 14,
        lineHeight: 21,
        fontWeight: 'normal',
        fontFamily: 'IranSans',
        letterSpacing: 0.25,
        color: 'white',
        textAlign: 'center'

    },

    spinner: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(50,70,110,0.3)',
        bottom: 0,
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9000,
    }

});